import * as React from 'react'

const BronzeMedal = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M18.768 11.51L13.548 2.93C13.208 2.35 12.598 2 11.928 2H5.33801C3.88801 2 2.97801 3.56 3.68801 4.82C5.00765 7.15472 6.87016 9.13729 9.11801 10.6C9.87801 11.19 10.818 11.51 11.788 11.51H18.768Z"
      fill="#0074BA"
    />
    <path
      d="M26.658 2H20.068C19.398 2 18.788 2.35 18.448 2.93L13.228 11.51H20.218C21.188 11.51 22.118 11.19 22.888 10.6C25.138 9.14 26.998 7.16 28.318 4.82C29.018 3.56 28.108 2 26.658 2Z"
      fill="#00A6ED"
    />
    <path
      d="M15.99 30C21.535 30 26.03 25.393 26.03 19.71C26.03 14.027 21.535 9.42 15.99 9.42C10.445 9.42 5.95001 14.027 5.95001 19.71C5.95001 25.393 10.445 30 15.99 30Z"
      fill="#D3883E"
    />
    <path
      d="M16 28.76C13.64 28.76 11.42 27.82 9.76002 26.11C8.0895 24.3997 7.15913 22.1007 7.17002 19.71C7.17002 17.29 8.09002 15.02 9.76002 13.31C10.5703 12.4726 11.5407 11.8067 12.6136 11.352C13.6864 10.8972 14.8398 10.6629 16.005 10.6629C17.1703 10.6629 18.3236 10.8972 19.3965 11.352C20.4693 11.8067 21.4397 12.4726 22.25 13.31C25.69 16.84 25.69 22.58 22.25 26.11C20.57 27.82 18.35 28.76 16 28.76ZM15.99 11.89C14.04 11.89 12.08 12.65 10.6 14.18C9.16013 15.6595 8.35925 17.6455 8.37002 19.71C8.37002 21.8 9.16002 23.76 10.6 25.24C11.2982 25.9646 12.1354 26.5409 13.0616 26.9344C13.9877 27.3279 14.9837 27.5305 15.99 27.53C18.03 27.53 19.94 26.72 21.38 25.24C24.35 22.19 24.35 17.23 21.38 14.18C20.6825 13.4544 19.8454 12.8775 18.9191 12.484C17.9928 12.0904 16.9965 11.8884 15.99 11.89Z"
      fill="#F3AD61"
    />
    <path
      d="M17.402 18.275L18.45 16.465C18.5355 16.3164 18.5804 16.1479 18.5804 15.9765C18.5804 15.8051 18.5355 15.6366 18.45 15.488C18.3649 15.3394 18.242 15.216 18.0938 15.1303C17.9455 15.0445 17.7773 14.9996 17.606 15H14.514C14.2604 15.0081 14.02 15.1146 13.8435 15.2968C13.667 15.479 13.5683 15.7228 13.5683 15.9765C13.5683 16.2302 13.667 16.474 13.8435 16.6562C14.02 16.8384 14.2604 16.9449 14.514 16.953H15.917L15.165 18.264C15.0275 18.4338 14.952 18.6455 14.951 18.864C14.951 19.404 15.389 19.841 15.928 19.841C16.538 19.841 17.036 20.339 17.036 20.949C17.036 21.559 16.538 22.058 15.928 22.058C15.46 22.058 15.043 21.763 14.89 21.325C14.8029 21.083 14.6238 20.8852 14.3915 20.7747C14.1593 20.6642 13.8927 20.6499 13.65 20.735C13.5293 20.7771 13.4182 20.8427 13.3231 20.9281C13.228 21.0135 13.1507 21.1169 13.0959 21.2323C13.041 21.3477 13.0096 21.4729 13.0034 21.6006C12.9973 21.7282 13.0165 21.8558 13.06 21.976C13.2726 22.5669 13.6619 23.0781 14.1749 23.4401C14.688 23.8022 15.3001 23.9977 15.928 24C16.7367 23.9992 17.512 23.6776 18.0838 23.1058C18.6556 22.534 18.9772 21.7587 18.978 20.95C18.9768 20.4043 18.8301 19.8688 18.5531 19.3986C18.2761 18.9284 17.8788 18.5406 17.402 18.275Z"
      fill="#633E19"
    />
  </svg>
))

BronzeMedal.displayName = 'BronzeMedal'

export { BronzeMedal }
